import apiClient from "../apiClient";
import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageContext from "../PageContext.jsx";

const BanksAdd = () => {
    const [currencies, setCurrencies] = useState([]);
    const [bank, setBank] = useState({
        Description: "",
        CurrencyID: "",
        AnnualInterestRate: "0.00",
        IsRetirement: 0,
    });

    const [error, setError] = useState(false);
    const sortedCurrencies = useMemo(
        () => [...currencies].sort((a, b) => (a.Description || "").localeCompare(b.Description || "")),
        [currencies]
    );

    const navigate = useNavigate();

    useEffect(() => {
        const fetchCurrencies = async () => {
            try {
                const res = await apiClient.get("/currencies");
                const rows = Array.isArray(res.data) ? res.data : [];
                const sorted = [...rows].sort((a, b) => (a.Description || "").localeCompare(b.Description || ""));
                setCurrencies(sorted);
                if (sorted.length > 0) {
                    setBank((prev) => ({ ...prev, CurrencyID: rows.find((row) => Number(row.IsDefault))?.CurrencyID || sorted[0].CurrencyID }));
                }
            } catch (err) {
                setError(true);
            }
        };
        fetchCurrencies();
    }, []);

    const handleChange = (e) => {
        const { name, type, checked, value } = e.target;
        setBank((prev) => ({ ...prev, [name]: type === "checkbox" ? (checked ? 1 : 0) : value }));
    };

    const handleClick = async (e) => {
        e.preventDefault();
        if (!bank.Description?.trim() || !bank.CurrencyID) return setError(true);
        try {
            await apiClient.post("/banks", bank);
            navigate("/Banks");
        } catch (err) {
            setError(true);
        }
    };
    
    return (
        <div className="page">
            <header className="page-header">
                <div>
                    <h1 className="page-title">Add Bank</h1>
                    <p className="page-subtitle"><Link to="/">Home</Link> / <Link to="/Banks">Banks</Link> / Add</p>
                </div>
            </header>
            <PageContext
                items={[
                    { label: "Home", to: "/" },
                    { label: "Banks", to: "/Banks" },
                    { label: "Add Bank" },
                ]}
                note="Create a new bank account and assign its working currency."
            />
            <section className="panel form-card">
                <div className="form">
                    <label htmlFor="bank-description">Bank Description</label>
                    <input
                        id="bank-description"
                        type="text"
                        placeholder="e.g. Equity Bank"
                        name="Description"
                        value={bank.Description}
                        onChange={handleChange}
                    />
                    <label htmlFor="bank-currency">Currency</label>
                    <select id="bank-currency" name="CurrencyID" onChange={handleChange} value={bank.CurrencyID}>
                        {sortedCurrencies.map((currency) => (
                            <option key={currency.CurrencyID} value={currency.CurrencyID}>
                                {currency.Description}
                            </option>
                        ))}
                    </select>
                    <label htmlFor="bank-interest-rate">Annual Interest Rate (%)</label>
                    <input
                        id="bank-interest-rate"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="e.g. 8.50"
                        name="AnnualInterestRate"
                        value={bank.AnnualInterestRate}
                        onChange={handleChange}
                    />
                    <label className="checkbox-row">
                        <input
                            type="checkbox"
                            name="IsRetirement"
                            checked={Boolean(bank.IsRetirement)}
                            onChange={handleChange}
                        />
                        <span>Retirement bank</span>
                    </label>
                    <div className="form-actions">
                        <button className="btn" onClick={handleClick}>Add Bank</button>
                        <Link className="btn-link" to="/Banks">Cancel</Link>
                    </div>
                    {error && <p className="notice notice-error">Could not save bank. Check input and try again.</p>}
                </div>
            </section>
        </div>
         );
    };

export default BanksAdd;
